import { AllowedEnv, DEFAULT_API_VERSION, ENVIRONMENTS, EnvDetails, SERVICE_API_VERSIONS } from "./env";

type AllowedDevEnv =
    | AllowedEnv.Beta
    | AllowedEnv.Dev
    | AllowedEnv.ProdTesting
    | AllowedEnv.FeatureStaging
    | AllowedEnv.Sandbox
    | AllowedEnv.Main;

export const IS_LOCAL_NX_DEV = process.env.NX_TASK_TARGET_CONFIGURATION === "development";

export const DEBUG = IS_LOCAL_NX_DEV;

// Local dev API key to bypass rate limiting during local development and E2E tests
// Set NX_LOCAL_DEV_API_KEY in .env file (not committed to git)
export const LOCAL_DEV_API_KEY = process.env.NX_LOCAL_DEV_API_KEY;

const cloudEnvRaw = process.env.NX_ENVIRONMENT;
const cloudEnv =
    cloudEnvRaw && Object.values(AllowedEnv).includes(cloudEnvRaw as AllowedEnv)
        ? (cloudEnvRaw as AllowedEnv)
        : undefined;

// Modify this
const devEnv: AllowedDevEnv = AllowedEnv.Main;

// Do not modify
const env: AllowedEnv = (() => {
    // prevents bad AWS deploys in prod
    if (window.location.origin.includes("app.loopscale")) return AllowedEnv.Main;
    if (window.location.origin.includes("alpha.loopscale")) return AllowedEnv.Sandbox;
    if (window.location.origin.includes("beta")) return AllowedEnv.Beta; // not full custom domain rn, but just search for branch

    if (IS_LOCAL_NX_DEV) return devEnv;

    return cloudEnv ?? AllowedEnv.Main;
})();

export const ENV_DETAILS: EnvDetails = ENVIRONMENTS[env];
export const GEO_API = "https://get.geojs.io/v1/ip";
export const MPC_API = ENV_DETAILS.mpcApi;
export const RUBY_API = ENV_DETAILS.rubyApi;
export const ENDURANCE_API = ENV_DETAILS.enduranceApi;
export const MARKETS_API = ENV_DETAILS.marketsApi;
export const PANDORA_API = ENV_DETAILS.pandoraApi;

// Privy appIds
const PRIVY_APP_IDS = {
    dev: "cmb81sjkr00pajs0mn8g2lovy", // Dev appId (no domain restrictions)
    prod: "cmsi2wf4x00t70cl127pwko42" // Production appId (domain restrictions)
};

// Privy appId: use dev appId when running locally, otherwise use prod appId
export const PRIVY_APP_ID = IS_LOCAL_NX_DEV ? PRIVY_APP_IDS.dev : PRIVY_APP_IDS.prod;

export const IS_PROD = env === AllowedEnv.Main;
export const IS_SANDBOX = env === AllowedEnv.Sandbox || env === AllowedEnv.Dev;

export const RPC_URL =
    ENV_DETAILS.rpcUrl ?? process.env.RPC_URL ?? "https://chryste-1f8w1a-fast-mainnet.helius-rpc.com/";

export const doesApiVersionMatch = (endpoint: string, headerVersion: string) => {
    const endpointKey = Object.entries(ENV_DETAILS).find(([, basePath]) => endpoint.includes(basePath))?.[0];

    // if unmatched api, version is always compatible
    if (!endpointKey) {
        return true;
    }
    const apiVersion = SERVICE_API_VERSIONS[endpointKey as keyof typeof SERVICE_API_VERSIONS] ?? DEFAULT_API_VERSION;

    return apiVersion === headerVersion;
};
